/** @format */

import {WidgetStat} from 'components/PropertyWidget/model';
import {ValueBox} from 'components/PropertyWidget/style';

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import WidgetFormattedNumber from 'components/PropertyWidget/components/WidgetFormattedNumber';

import {sumSeries} from 'features/mediaplan-progress/helpers/sumSeries';

import {factSeriesFromChartData} from '../progress-adapter/seriesFromChartData';

export interface GetStatsTypeScatterNotesOptions {
  data: CommonChartData[];
}

const getStatsTypeScatterNotes = ({data}: GetStatsTypeScatterNotesOptions): WidgetStat[] => {
  const fact = sumSeries(factSeriesFromChartData(data));
  return [
    {
      heading: 'Всего заметок',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={fact} />
        </ValueBox>
      ),
      dontDrawDividerAfter: true,
    },
  ];
};

export {getStatsTypeScatterNotes};
